import fp from 'lodash/fp';
import { put, call } from 'redux-saga/effects';
import { toastr } from 'react-redux-toastr';
import * as Api from '../../../services/fbm-api';
import { sagaRoutineRequest } from '../../../helpers/saga';
import { onDeletedReportTemplate } from '../../actions/report-template';
import {
  fetchReportTemplates as fetchReportTemplatesRoutine,
  createReportTemplate as createReportTemplateRoutine,
  updateReportTemplate as updateReportTemplateRoutine,
  deleteReportTemplate as deleteReportTemplateRoutine
} from './routines';

export const fetchReportTemplates = ({ payload }) =>
  sagaRoutineRequest(fetchReportTemplatesRoutine, {
    request: () => call(Api.fetchReportTemplates, fp.pick('qs', payload) || {})
  });

export const createReportTemplate = ({ payload }) =>
  sagaRoutineRequest(createReportTemplateRoutine, {
    request: () => call(Api.createReportTemplate, { body: payload }),
    *success() {
      yield toastr.success('Success', `Preset created.`);
    }
  });

export const updateReportTemplate = ({ payload }) =>
  sagaRoutineRequest(updateReportTemplateRoutine, {
    request: () =>
      call(Api.updateReportTemplate, fp.pick(['id', 'body'], payload)),
    *success() {
      yield toastr.success('Success', `Preset updated.`);
    }
  });

export const deleteReportTemplate = ({ payload: template }) =>
  sagaRoutineRequest(deleteReportTemplateRoutine, {
    request: () => call(Api.deleteReportTemplate, template.id),
    *success() {
      yield toastr.success('Success', `Deleted preset "${template.fileName}".`);
      yield put(onDeletedReportTemplate({ id: template.id }));
    }
  });
